import React from "react";

export default function SlowLoading() {
    const slowLoadingMessage = "Nossos servidores estão demorando pra responder, aguarde mais um pouco por favor!";

    return (
        <p className='loading-slow-message'>{slowLoadingMessage}</p>
    )
}